//Styles
import Styles from "./AppBar.module.scss"

import { ReactComponent as SidebarIcon } from "../../../icons/app/sidebar.svg"
import { ReactComponent as LeftIcon } from "../../../icons/app/left.svg"
import { ReactComponent as RightIcon } from "../../../icons/app/right.svg"
import SearchBox from "../../search_box/SearchBox"
import { ReactNode } from "react"

interface AppBarProps{
    title:string;
    windowOptions:ReactNode;
    onClickPreviousIcon?:()=>void;
    onClickNextIcon?:()=>void;
    onSidebarIconClick:()=>void;

}

const AppBar = ({title,windowOptions,onClickNextIcon,onClickPreviousIcon,onSidebarIconClick}:AppBarProps) => {
    return (
        <div className={Styles.container}>  
            <div className={Styles.left_container}>
                {windowOptions && windowOptions}
                <SidebarIcon onClick={onSidebarIconClick}/>
                <LeftIcon onClick={onClickPreviousIcon}/>
                <RightIcon onClick={onClickNextIcon} />
                {title}
            </div>
            <div className={Styles.right_container}>
                <SearchBox title={title}/>
            </div>
        </div>
    )
}

export default AppBar
